import React from "react";
import AudbilityStatusTag from "../../../shared/components/AudbilityStatusTag/AudbilityStatusTag";
import { CREATED_AT_PREFIX } from "../../constants";
import classes from "./UserSummary.module.scss";

const UserSummary = ({ name, email, status, statusKey, createdAt }) => (
  <div className={classes.UserSummary}>
    <div className={classes.NameRow}>
      <span className={classes.Name}>{name}</span>
      <AudbilityStatusTag statusKey={statusKey} label={status} />
    </div>

    <div className={classes.InfoRow}>
      <span>{email}</span>
      <span className={classes.CreatedAt}>
        {CREATED_AT_PREFIX} {createdAt}
      </span>
    </div>
  </div>
);

export default UserSummary;
